export default __webpack_public_path__ + "static/media/unknown_thumb.d85692f7.jpg";